import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_my_einvoice_submission_history_export_file_hdr_RowClass} from '../../../dbschema';

export class EinvoiceSubmissionHistoryExportFileContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_submission_history_export_file_hdr: bl_fi_my_einvoice_submission_history_export_file_hdr_RowClass = new bl_fi_my_einvoice_submission_history_export_file_hdr_RowClass();
}